import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { Accordion, Card, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import PerfectScrollbar from 'react-perfect-scrollbar';
import * as action from './Store/SystemMasters.action';
import ConfirmationPopup from '../../Components/ModalPopup/ConfirmationPopup';
import { useComponent } from '../UserSetting/UsersLibrary/UserRights';
import Loader from '../../Components/Utility/Loader/Loader';
import CustomTooltip from '../../Components/Tooltip/CustomTooltip';

const tempObj = {
  name: null,
  isEmpty: false,
  isNew: true,
  isActive: true,
  isActiveIncoterms: false,
  _id: '',
};

function Incoterms() {
  const incotermsKeyName = 'incoterms';
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails,
    Users: { logInRights },
  } = reducer;
  const { incotermsList } = SystemMastersDetails;
  const { userInfo } = UserDetails;
  const { CheckActionPermission } = useComponent();
  const [userRights, setUserRights] = useState({});
  useEffect(() => {
    if (logInRights) {
      setUserRights(logInRights);
    }
  }, [logInRights]);
  const MasterAddEditAccess = CheckActionPermission(userRights, 'masters', 'incoterms', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(userRights, 'masters', 'incoterms', 'delete');
  const { t } = useTranslation('common');
  const loggedInUserId = userInfo.userId;

  const [isLoadingIncoterms, setIsLoadingIncoterms] = useState(false);
  const [showIncoterms, setShowIncoterms] = useState(false);
  const [isIncotermsUnique, setIsIncotermsUnique] = useState(true);
  const [buttonDownIncoterms, setButtonDownIncoterms] = useState(true);
  const [incotermsBtnDisable, setIncotermsBtnDisable] = useState(false);
  const [addingIncoterms, setAddingIncoterms] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [isIncoterms, setIsIncoterms] = useState(false);
  const [incotermsData, setIncotermsData] = useState([]);
  const [isUniqIncotermsId, setIsUniqIncotermsId] = useState([]);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [scrollEl, setScrollEl] = useState();
  useEffect(() => {
    if (scrollEl) {
      scrollEl.scrollTop = 1000;
    }
  }, [scrollEl]);
  useEffect(() => {
    setIncotermsData(incotermsList);
    if (addingIncoterms) {
      setIncotermsData([
        ...incotermsList,
        {
          name: null,
          isEmpty: false,
          isNew: true,
          isActive: true,
          _id: '',
        },
      ]);
    }
  }, [incotermsList, addingIncoterms]);

  const callApi = async () => {
    setButtonDownIncoterms(!buttonDownIncoterms);
    setIsLoadingIncoterms(true);
    buttonDownIncoterms ? setShowIncoterms(true) : setShowIncoterms(false);
    isEmpty(incotermsData) && (await dispatch(action.getIncotermsDetails()));
    setIsLoadingIncoterms(false);
  };

  useEffect(() => {
    const array = [];
    incotermsData.forEach((ele, index) => {
      incotermsData.forEach((obj, places) => {
        if (index !== places && ele?.name === obj?.name) {
          array.push(ele);
        }
      });
    });
    if (isEmpty(array)) {
      setIsIncotermsUnique(isEmpty(array));
      setIsUniqIncotermsId([]);
    }
  }, [incotermsData]);

  const handleDefaultChange = (index) => {
    const incotermValue = [...incotermsData];
    incotermValue.forEach((item, i) => {
      incotermValue[i] = {
        ...incotermValue[i],
        isActiveIncoterms: i === index,
      };
    });
    setIncotermsData(incotermValue);
  };

  const handleChnaged = (event, i) => {
    const finals = [...incotermsData];
    setIsIncotermsUnique(true);
    setIsUniqIncotermsId([]);
    finals[i] = {
      ...finals[i],
      name: event.target.value,
      isEmpty: event.target.value === '',
    };
    const arr = [];
    const arrIndex = [];
    finals.forEach((ele, ind) => {
      finals.forEach((objs, index) => {
        if (ele.name === objs.name && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });
    if (!isEmpty(arr)) {
      const arrs = [...arrIndex];
      const removeArss = Math.min(...arrs);
      const newArr = arrIndex.filter((ele) => ele !== removeArss);
      setIsUniqIncotermsId([...newArr]);
    }
    setIsIncotermsUnique(isEmpty(arr));
    let isDisableIncoterms = false;
    finals.forEach((finalElement) => {
      if (isEmpty(finalElement?.name?.trim())) {
        isDisableIncoterms = true;
      }
    });
    setIncotermsBtnDisable(isDisableIncoterms);
    setIncotermsData(finals);
  };

  const addIncoterms = async () => {
    if (!showIncoterms) {
      setAddingIncoterms(true);
      setButtonDownIncoterms(!buttonDownIncoterms);
      setIsLoadingIncoterms(true);
      buttonDownIncoterms ? setShowIncoterms(true) : setShowIncoterms(false);
      isEmpty(incotermsData) && (await dispatch(action.getIncotermsDetails()));
      setIsLoadingIncoterms(false);
    } else if (!isEmpty(incotermsData)) {
      setIncotermsData([...incotermsData, tempObj]);
    } else {
      setIncotermsData([tempObj]);
    }
  };

  const handleDelete = (id) => {
    if (typeof id === 'number' || id === '') {
      incotermsData.splice(id, 1);
      let incotermsDel = false;
      incotermsData.forEach((incotermsElement) => {
        if (isEmpty(incotermsElement?.name?.trim())) {
          incotermsDel = true;
        }
      });
      setIncotermsBtnDisable(incotermsDel);
      setIsUniqIncotermsId([]);
      setIsIncotermsUnique(true);
      setIncotermsData([...incotermsData]);
    } else {
      setDeleteId(id);
      setShowConfirmation(true);
    }
  };

  const saveIncoterms = async () => {
    setIsIncoterms(true);
    if (!isEmpty(incotermsData)) {
      const emptyField = incotermsData.filter((britem) => britem.name === null || britem.name === '');

      if (isEmpty(emptyField)) {
        const data = incotermsData.map((brnobj) => {
          return {
            ...brnobj,
            name: brnobj?.name?.trim(),
            isActiveIncoterms: brnobj?.isActiveIncoterms || false,
          };
        });
        const finalSaveParams = {
          title: incotermsKeyName,
          names: JSON.stringify(data),
        };
        setAddingIncoterms(false);
        await dispatch(action.saveToSystemMaster(finalSaveParams, t));
        setAddingIncoterms(false);
        await dispatch(action.getIncotermsDetails());
      } else {
        const newState = incotermsData.map((brobj) => (brobj?.isEmpty === false && brobj.name === null ? { ...brobj, isEmpty: true } : brobj));
        setIncotermsData(newState);
      }
    }
    setIsIncoterms(false);
  };

  const activeInactiveClicked = (id) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const finalDeleteParams = {
      loggedInUserId,
      incotermsId: deleteId,
      title: incotermsKeyName,
    };
    await dispatch(action.deleteFromSystemMasters(finalDeleteParams, t));
    setIncotermsData([...incotermsList]);
    setIsLoadingConf(false);
    setShowConfirmation(false);
    await dispatch(action.getIncotermsDetails());
  };

  const activeInactiveConfirmed = async () => {
    let final = {};
    setIsLoadingConf(true);
    incotermsData.forEach((ele) => {
      if (ele._id === activeInactiveID) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          title: incotermsKeyName,
        };
        final = data;
      }
    });
    await dispatch(action.setActiveInactive(final, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);
    setIncotermsData([...incotermsList]);
  };

  const activeClass = (item) => {
    return item.isActive ? 'icon-Eye-Open' : 'icon-Eye-Closed';
  };
  return (
    <>
      <Accordion className="mb-4 master-accordian">
        <Card>
          <Card.Header>
            <div className="title-container">
              <p>{t('INCOTERMS.TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <CustomTooltip tooltipText={t(showIncoterms ? 'CUSTOM_ATTRIBUTES.CLOSE' : 'CUSTOM_ATTRIBUTES.OPEN')}>
                <button className="btn d-inline-flex p-0" onClick={() => callApi()} type="button">
                  {!buttonDownIncoterms ? <i className="icon-new-down-arrow-icon icon-inverse f-24" /> : <i className="icon-new-down-arrow-icon f-24" />}
                </button>
              </CustomTooltip>
            </div>
          </Card.Header>
          {showIncoterms && (
            <Card.Body>
              {isLoadingIncoterms ? (
                <Loader />
              ) : (
                <PerfectScrollbar
                  containerRef={(ref) => {
                    setScrollEl(ref);
                  }}
                >
                  <ul>
                    {!isEmpty(incotermsData) &&
                      incotermsData.map((item, i) => {
                        return (
                          <li key={item?._id}>
                            <div className="input-container">
                              <input
                                key={item?._id}
                                maxLength={50}
                                value={item?.name || typeof item?.name === 'number' ? item?.name : ''}
                                type="text"
                                onChange={(e) => handleChnaged(e, i)}
                                disabled={!MasterAddEditAccess}
                              />
                              {!isEmpty(isUniqIncotermsId) && isUniqIncotermsId?.includes(i) && (
                                <label htmlFor={item?._id} className="text-danger m-0 p-1">
                                  {t('SYSTEM_MASTER_TABLE.THIS_ENTRY_ALREADY_EXISTS')}
                                </label>
                              )}
                              {item?.isEmpty && (item?.name === null || item?.name === '') && (
                                <label htmlFor={item?._id} className="text-danger m-0 p-1">
                                  {t('INCOTERMS.TITLE')} {t('SYSTEM_MASTER_TABLE.ENTRY_REQUIRED')}
                                </label>
                              )}
                              {item?.isNew && !isEmpty(item?.name) && isEmpty(item?.name?.trim()) && (
                                <label htmlFor={item?._id} className="text-danger m-0 p-1">
                                  {t('INCOTERMS.TITLE')} {t('SYSTEM_MASTER_TABLE.ENTRY_IS_INVALID')}
                                </label>
                              )}
                            </div>
                            <div className="input-action">
                              {!item?.isDefault && MasterAddEditAccess && (
                                <CustomTooltip tooltipText={t('SYSTEM_MASTER_TABLE.ACTIVE/INACTIVE')}>
                                  <button
                                    onClick={() => activeInactiveClicked(item?._id)}
                                    id={item._id}
                                    type="button"
                                    aria-label="Active/Inactive"
                                    disabled={!MasterAddEditAccess}
                                  >
                                    <span className={activeClass(item)} />
                                  </button>
                                </CustomTooltip>
                              )}
                              {!item?.isDefault && MasterDeleteAccess && (
                                <CustomTooltip tooltipText={t('SYSTEM_MASTER_TABLE.DELETE')}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      handleDelete(item._id ? item._id : i);
                                    }}
                                    aria-label="Delete"
                                  >
                                    <span className="icon-Delete f-24 mt-3" />
                                  </button>
                                </CustomTooltip>
                              )}
                              <CustomTooltip tooltipText={t('GREEDY_MENU_TABS.SET_US_DEFAULT')}>
                                <div className="custom-radio no-label radio-dark mb-0 ml-8">
                                  <input
                                    type="radio"
                                    id={`defaultIncoterm${i}`}
                                    name="defaultIncoterm"
                                    checked={item?.isActiveIncoterms || false}
                                    onChange={() => handleDefaultChange(i)}
                                    disabled={!MasterAddEditAccess}
                                  />
                                  <label
                                    htmlFor={`defaultIncoterm${i}`}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    className="tooltip-wrapper chklabel align-items-start mb-3"
                                  />
                                </div>
                              </CustomTooltip>
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </PerfectScrollbar>
              )}

              {MasterAddEditAccess && (
                <div className="add-btn-container">
                  <CustomTooltip tooltipText={t('SYSTEM_MASTER_TABLE.ADD')}>
                    <button
                      type="button"
                      className="btn btn-outline sm ml-auto mr-0 p-0"
                      onClick={addIncoterms}
                      disabled={incotermsBtnDisable || !isIncotermsUnique}
                    >
                      {isIncoterms ? <Spinner /> : <i className="icon-Add" />}
                    </button>
                  </CustomTooltip>
                </div>
              )}

              {MasterAddEditAccess ? (
                <div className="section-save">
                  <button
                    aria-label="Save"
                    type="button"
                    className="btn ml-auto p-0"
                    onClick={saveIncoterms}
                    disabled={incotermsBtnDisable || !isIncotermsUnique}
                  >
                    {isIncoterms ? <Spinner /> : <i className="icon-Tick-1 f-24" />}
                  </button>
                </div>
              ) : (
                ''
              )}
            </Card.Body>
          )}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={deleteConfirmed}
          title={t('INCOTERMS.DELETE_TITLE')}
          message={t('INCOTERMS.DELETE_MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={activeInactiveConfirmed}
          title={t('INCOTERMS.ACTIVATE_DEACTIVATE_TITLE')}
          message={t('INCOTERMS.ACTIVATE_DEACTIVATE_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}
export default Incoterms;
